// src/UIElements/Logs/Logs.js
import { LogLogic } from './logLogic';
import './logs.css';


const Logs = () => {
  const {
    logs,
    currentPage,
    totalPages,
    handlePageChange,
    PAGE_SIZE
  } = LogLogic();

  const trimLongWords = (text, maxLen = 40) =>
    text
      .split(' ')
      .map(word => (word.length > maxLen ? word.slice(0, maxLen) + '...' : word))
      .join(' ');

  return (
     <div className="main-content">
      <div className="p-3 mb-0 mt-1 custom-bg-white rounded">
        <div className="d-flex justify-content-between align-items-center">
          <span className="m-0 title">Logs</span>
        </div>
      </div>

      {totalPages > 0 && (
        <div className="d-flex justify-content-end mt-3">
          <nav>
            <ul className="pagination rounded-pagination">
              <li>
                <button
                  className="page-btn-1"
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  &lt;
                </button>
              </li>
              <li>
                <button className="page-btn active" disabled>
                  {currentPage}
                </button>
              </li>
              <li>
                <button
                  className="page-btn-1"
                  disabled={currentPage === totalPages}
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  &gt;
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}

      <div className="table-content-Referral">
        <table className="table table-bordered">
          <thead className="thead-dark">
            <tr>
              <th>SL.NO</th>
              <th>Description</th>
              <th>Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {logs.length > 0 ? (
              logs.map((log, index) => (
                <tr key={index}>
                  <td>{(currentPage - 1) * PAGE_SIZE + index + 1}</td>
                  <td>{trimLongWords(log.Description)}</td>
                  <td>{new Date(log.AddedTimeStamp).toLocaleString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3">No logs available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Logs;
